﻿﻿import { IUser } from './user';

export interface ICommunicationLogNotes {
    id: number;
    communicationLogId: number;
    logDateTime: string;
    notes: string;
    createdBy: number;
    createdDate: string;
    createdByUser: IUser;
}
